import { mapExchange, type Exchange } from "urql";
import { classifyApiError, type ReleaseStore } from "./releaseLogic";

// urql の通信を release store へ伝える（docs/daytime_deployment_technical_design.md 6.2 / 6.3）。
// - 実行中の mutation は「処理中」として数え、その間は自動更新しない
// - mutation の成功で公開版を確認し直す
// - 旧画面の契約エラーを受けたら更新を案内する。それ以外のエラーは通常の扱いのまま（握りつぶさない）
export const releaseExchange = (store: ReleaseStore, clientBuildId: string): Exchange => {
  const ends = new Map<number, () => void>();
  const finish = (key: number) => {
    ends.get(key)?.();
    ends.delete(key);
  };
  return mapExchange({
    onOperation(operation) {
      if (operation.kind === "mutation") ends.set(operation.key, store.beginRequest());
      if (operation.kind === "teardown") finish(operation.key);
    },
    onResult(result) {
      const { operation, error } = result;
      if (operation.kind === "mutation") {
        finish(operation.key);
        if (!error) store.emit("saved");
      }
      if (!error) return;
      const status = (error.response as Response | undefined)?.status ?? (error.networkError ? 0 : 200);
      const kind = classifyApiError({
        clientBuildId,
        publishedBuildId: store.snapshot().publishedBuildId,
        status,
        graphQLErrors: error.graphQLErrors.map((e) => ({ message: e.message, extensions: e.extensions })),
        networkError: Boolean(error.networkError),
      });
      if (kind === "stale-contract") store.emit("stale-contract");
    },
  });
};
